import React, {FC, useState, useEffect} from "react"
import qs from "qs"

import {getUserAccountLatestLogosCookie, UserAccountForCookie} from "@irati/utils/cookies/userAccountCookie"
import {FormattedMessage} from "@irati/utils/lang"
import {RouterLink, ButtonLink} from "@irati/ui/src/Link"
import {H1, Body} from "@irati/ui/src/Typography"
import Flex from "@irati/ui/src/Flex"
import perkboxBalloon from "@irati/ui/images/perkboxBalloon.svg"

import LoginBlock from "../../../components/LoginBlock"
import {StyledImage, StyledH5} from "./styled"

interface Props {
  id: string
  userAccounts: UserAccountForCookie[]
}

interface QueryParams {
  redirectTo?: string
}

const AccountLogin: FC<Props> = ({id: idNamespace, userAccounts}) => {
  const [newAccounts, setNewAccounts] = useState(userAccounts)

  const makeUrl = (url: string) => {
    const query = qs.parse(window.location.search.replace("?", "")) as QueryParams
    const pathname = query.redirectTo ?? "/"
    return `${url}${pathname}`
  }

  const helpLinks = [
    <FormattedMessage
      id="platform.defaultLogin.multipleTenants.help.otherDomain"
      values={{
        link: (
          <RouterLink to="/welcome/domain">
            <FormattedMessage id="platform.defaultLogin.multipleTenants.help.other.text" />
          </RouterLink>
        )
      }}
    />,
    <RouterLink to="/welcome/accounts">
      <FormattedMessage id="platform.defaultLogin.multipleTenants.help.accounts" />
    </RouterLink>
  ]

  useEffect(() => {
    if (userAccounts) {
      getUserAccountLatestLogosCookie(userAccounts, window.location.hostname).then((updatedUserAccounts) => {
        setNewAccounts(updatedUserAccounts)
      })
    }
  }, [])

  return (
    <div id={idNamespace} className="account_login-container">
      <LoginBlock id={idNamespace} image={perkboxBalloon} helpLinks={helpLinks}>
        <H1 marginBottom={2}>
          <FormattedMessage id="platform.defaultLogin.multipleTenants.header" />
        </H1>
        <Body marginBottom={3}>
          <FormattedMessage id="platform.defaultLogin.multipleTenants.body" />
        </Body>
        {newAccounts &&
          newAccounts.map(({subdomain, image, url}, index) => {
            return (
              <Flex key={subdomain} marginBottom={index < newAccounts.length - 1 ? 4 : 0} alignItems="center">
                <StyledImage src={image} />
                <StyledH5>{subdomain}</StyledH5>
                <ButtonLink primary href={makeUrl(url)}>
                  <FormattedMessage id="platform.defaultLogin.multipleTenants.login" />
                </ButtonLink>
              </Flex>
            )
          })}
      </LoginBlock>
    </div>
  )
}

export default AccountLogin
